const cadesSignature = {
  default: {
    title: 'Descargar documento en p7s',
    description: 'Tengo el documento firmado y quiero descargarlo en formato p7s.',
  },
};

export default cadesSignature;
